import { getModelVersionESSForProject } from '@/domain/impact/utils/get-model-version-for-project';
import { EssQuestions } from '@/domain/impact-ess/entities/question.entity';
import { ModelVersionESS } from '@/domain/project/entities/project.entity';
import {
  selectCurrentProject,
  selectCurrentProjectMode,
} from '@/domain/project/project.selectors';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

export const getImpactEssQuestions = createAppAsyncThunk(
  'impactEss/getImpactEssQuestions',
  async (
    { essModelVersion }: { essModelVersion?: ModelVersionESS },
    { extra: { impactEssGateway, snackbarGateway }, getState },
  ): Promise<EssQuestions> => {
    try {
      const currentProject = selectCurrentProject(getState());
      const projectMode = selectCurrentProjectMode(getState());
      const modelVersion = getModelVersionESSForProject(
        projectMode,
        currentProject,
      );
      const answers = await impactEssGateway.getImpactEssQuestions(
        essModelVersion || modelVersion,
      );
      return answers;
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('GetImpactAnswers.Message.error'));
}
